import styled from 'styled-components'
import { calculateResponsiveSize } from 'helpers/calculateResponsiveSize'
import { mediaMax } from 'helpers/mediaQueries'

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: ${calculateResponsiveSize(200)} 11vw;
  display: flex;
  justify-content: center;
  ${mediaMax('tabletLandscape')} {
    padding: 30vh 20px 10vh;
  }
  ${({ $background }) => {
    switch ($background) {
      case 'first':
        return `
          background: linear-gradient(180deg, #3f62ae 0%, #e7e4d5 100%);
        `
      case 'second':
        return `
           background: linear-gradient(180deg, #D77E5D 9.48%, #3F62AE 100%);
        `
      case 'third':
        return `
          background: linear-gradient(180deg, #3F62AE 0%, #D77E5D 100%);
        `
      case 'fourth':
        return `
          background: linear-gradient(180deg, #3F62AE 0%, #D77E5D 100%);`
      default:
        return `
           ""
        `
    }
  }}
`

export const Header = styled.header`
  width: ${({ $multiColumn }) => ($multiColumn ? `60%` : '100%')};
  flex-shrink: 0;
  ${mediaMax('desktopSm')} {
    width: 100%;
    text-align: center;
  }
`

export const Content = styled.div`
  width: 100%;
  max-width: ${({ $multiColumn }) => ($multiColumn ? `` : '55vw')};
  gap: ${({ $multiColumn }) =>
    $multiColumn ? ` ${calculateResponsiveSize(60)}` : ''};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ $multiColumn }) => ($multiColumn ? `row;` : 'column')};
  text-align: ${({ $multiColumn }) => ($multiColumn ? `` : 'center')};
  ${mediaMax('desktopSm')} {
    max-width: 80vw;
    flex-direction: column;
    gap: 0;
  }
  ${mediaMax('tabletLandscape')} {
    max-width: 100%;
    /* padding: 0; */
  }
`

export const Subtitle = styled.h4`
  margin-bottom: ${calculateResponsiveSize(32)};
  font-size: ${calculateResponsiveSize(18)};
  font-family: 'proxima_nova_semibold', san-serif;
  letter-spacing: ${calculateResponsiveSize(1.8)};

  ${mediaMax('desktopSm')} {
    font-size: 18px;
    letter-spacing: 1.8px;
    margin-bottom: 32px;
  }
  ${mediaMax('tabletLandscape')} {
    font-size: 14px;
    letter-spacing: 1.4px;
    margin-bottom: 24px;
  }
`

export const Title = styled.h2`
  font-weight: 400;
  margin-bottom: ${calculateResponsiveSize(50)};
  font-size: ${calculateResponsiveSize(96)};
  line-height: ${calculateResponsiveSize(108)};
  letter-spacing: ${calculateResponsiveSize(-1)};
  white-space: pre-wrap;

  ${mediaMax('desktopSm')} {
    font-size: 72px;
    line-height: 1.2;
    margin-bottom: 50px;
    white-space: normal;
  }
  ${mediaMax('tabletLandscape')} {
    font-size: 48px;
    line-height: 1;
    margin-bottom: 16px;
    letter-spacing: -1px;
  }
`

export const Description = styled.p`
  font-size: ${calculateResponsiveSize(21)};
  line-height: ${calculateResponsiveSize(36)};
  padding-top: ${({ $multiColumn }) =>
    $multiColumn ? ` ${calculateResponsiveSize(54)};` : ''};
  white-space: pre-wrap;
  margin: 0 auto;
  ${mediaMax('desktopSm')} {
    padding-top: 0;
    font-size: 18px;
    line-height: 1.6;
    width: 100%;
    white-space: normal;
  }
  ${mediaMax('tabletLandscape')} {
    text-align: center;
  }
`
